<ng-container [ngTemplateOutlet]="template"> </ng-container>

<ng-template #template>
  <form [formGroup]="formGroup">
    <div flexLayout="row wrap" flexLayoutAlign="start center" flexLayoutGap="1rem">
      @for (tagType of tagTypes; track tagType) {
        <mat-form-field flex appearance="fill" class="custom-selector-field">
          <mat-label>{{ tagType | tagTypeDisplayName | async }}</mat-label>
          <mat-select
            panelClass="custom-select-panel"
            [formControl]="formControls[tagType]"
            multiple
            (selectionChange)="onTagChanged($event.value, tagType)"
          >
            @if (isRootTagType(tagType)) {
              <input
                class="searchInput"
                placeholder="Search..."
                (input)="setOptions(tagType, $event.target.value)"
              />

              @for (tagGroup of optionsMap[tagType]; track tagGroup.tag.tagId) {
                <mat-option [value]="tagGroup.tag.tagId">
                  {{ tagGroup.tag.displayName }}
                </mat-option>
              }
            } @else {
              @for (tagGroup of getSelectedGrouping(tagType); track tagGroup.tag.tagId) {
                <mat-optgroup [label]="tagGroup.tag.displayName">
                  @for (
                    childTagGroup of getChildrenOfType(tagGroup.children, tagType);
                    track childTagGroup.tag.tagId
                  ) {
                    <mat-option [value]="childTagGroup.tag.tagId">
                      {{ childTagGroup.tag.displayName }}
                    </mat-option>
                  }
                </mat-optgroup>
                <mat-divider></mat-divider>
              }
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </form>
</ng-template>
